/* KAKAVY public policy visibility fix start */
(() => {
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const textNodes = (root) => {
    if (!root) return [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const result = [];
    while (walker.nextNode()) result.push(walker.currentNode);
    return result;
  };
  const replaceText = (root, from, to) => {
    for (const node of textNodes(root)) {
      if (node.nodeValue.includes(from)) node.nodeValue = node.nodeValue.replaceAll(from, to);
    }
  };
  const replaceExact = (root, from, to) => {
    if (!root) return;
    const matches = [...root.querySelectorAll('p, div, span')]
      .filter((element) => clean(element.textContent) === clean(from));
    const target = matches.find((element) => ![...element.children]
      .some((child) => clean(child.textContent) === clean(from))) || matches.at(-1);
    if (target) target.textContent = to;
  };
  const removeParagraph = (root, value) => {
    if (!root) return;
    for (const paragraph of root.querySelectorAll('p')) {
      if (clean(paragraph.textContent) === clean(value)) paragraph.remove();
    }
  };
  const addIdentity = (root) => {
    if (!root || clean(root.textContent).includes('Kakavy is a brand operated by MoraDoll Inc.')) return;
    const paragraph = document.createElement('p');
    paragraph.textContent = 'Kakavy is a brand operated by MoraDoll Inc.';
    root.insertBefore(paragraph, root.firstChild);
  };
  const run = () => {
    const route = location.pathname.replace(/\/$/, '');
    const policy = document.querySelector('.shopify-policy__body .rte')
      || document.querySelector('.shopify-policy__body');
    if (route === '/policies/shipping-policy') {
      const oldOpening = 'We will process orders within 48 hours. After the order is processed, tracking information will be available online within 3 days. This means your shipping information will be available for online tracking within 1-5 days.';
      const newOpening = 'Orders are processed within 48 hours. After processing, tracking information is generally available online within 1–5 days.';
      replaceExact(policy, oldOpening, newOpening);
      replaceText(policy, oldOpening, newOpening);
      removeParagraph(policy, 'All orders are processed within 3–5 business days before shipment from our warehouse.');
      removeParagraph(policy, 'All orders are processed within 3-5 business days before shipment from our warehouse.');
      removeParagraph(policy, 'Due to the Chinese New Year, our holiday period is from February 7th to February 22nd. Orders placed after February 7th will be shipped within 3 days after February 23rd.');
      if (policy && !clean(policy.textContent).includes('Free worldwide shipping is available on orders of US$39 or more.')) {
        const paragraph = document.createElement('p');
        paragraph.textContent = 'Free worldwide shipping is available on orders of US$39 or more. Orders under US$39 ship for a flat US$5.99.';
        policy.insertBefore(paragraph, policy.children[1] || null);
      }
    } else if (route === '/policies/refund-policy') {
      replaceText(policy, 'Unfortunately, we cannot accept returns on sale items or gift cards.', 'Unfortunately, we cannot accept returns on gift cards.');
    } else if (route === '/policies/contact-information' || route === '/policies/terms-of-service') {
      addIdentity(policy);
    } else if (route === '/pages/help-center') {
      const root = document.querySelector('main') || document.body;
      const oldWorldwide = 'Yes, we ship all over the world. Shipping costs will apply, and will be added at checkout. We run discounts and promotions all year, so stay tuned for exclusive deals.';
      const newWorldwide = 'Yes. We ship worldwide. Orders of US$39 or more qualify for free worldwide shipping, while orders under US$39 ship for a flat US$5.99.';
      const oldDelivery = 'It depends on where you are. Orders processed here will take 5-7 business days to arrive. Overseas deliveries can take anywhere from 7-16 days. Delivery details will be provided in your confirmation email.';
      const newDelivery = 'Orders are processed within 48 hours. Delivery time depends on the destination and carrier. International tracking information is generally available online within 1–5 days after processing.';
      replaceExact(root, oldWorldwide, newWorldwide);
      replaceText(root, oldWorldwide, newWorldwide);
      replaceExact(root, oldDelivery, newDelivery);
      replaceText(root, oldDelivery, newDelivery);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
/* KAKAVY public policy visibility fix end */
